export default __webpack_public_path__ + "static/media/three.b7a5f8e4.png";